import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  ccs: {
    position: 'absolute',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    color: theme.palette.primary.main,

    '& > div': {
      cursor: 'pointer',

      '&:hover': {
        textDecoration: 'underline'
      }
    },

    '& > :first-child': {
      marginRight: '4px'
    }
  },

  input: {
    flex: 1,
    border: 'none',
    height: '31px',
    padding: '0',
    outline: 'none',
    background: 'transparent',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  }
}))

export default useStyles
